import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const CallToAction = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-primary to-accent relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 rounded-full bg-white animate-pulse-subtle"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 rounded-full bg-white animate-pulse-subtle" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/2 left-1/3 w-24 h-24 rounded-full bg-white animate-pulse-subtle" style={{ animationDelay: '2s' }}></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <div className="animate-fade-in">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            Ready to Experience Authentic Street Food?
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Visit us today and discover why Bengaluru loves Taco Street. Fresh flavors, warm vibes, and genuine connections await.
          </p>

          <div className="flex flex-wrap gap-4 justify-center">
            <Link to="/menu">
              <Button
                variant="secondary"
                size="lg"
                iconName="Menu"
                iconPosition="left"
                className="bg-white text-primary hover:bg-white/90"
              >
                Explore Menu
              </Button>
            </Link>
            <Link to="/locations">
              <Button
                variant="outline"
                size="lg"
                iconName="MapPin"
                iconPosition="left"
                className="border-white text-white hover:bg-white/10"
              >
                Find Locations
              </Button>
            </Link>
          </div>

          <div className="mt-12 grid sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl">
              <Icon name="Clock" size={32} color="#FFFFFF" className="mx-auto mb-3" />
              <p className="text-white font-semibold mb-1">Open Daily</p>
              <p className="text-white/80 text-sm">11:00 AM - 11:00 PM</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl">
              <Icon name="Phone" size={32} color="#FFFFFF" className="mx-auto mb-3" />
              <p className="text-white font-semibold mb-1">Call Us</p>
              <p className="text-white/80 text-sm">+91 80 1234 5678</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl">
              <Icon name="Mail" size={32} color="#FFFFFF" className="mx-auto mb-3" />
              <p className="text-white font-semibold mb-1">Email Us</p>
              <p className="text-white/80 text-sm">hello@tacostreet.in</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;